export default "__VITE_ASSET__869289c9__"